module.exports = __webpack_public_path__ + "img/s3.0cbd5f70.jpg";